import React, { Component } from 'react'
import { connect, Redirect, UserList, T } from 'components'
import { userCriteria, criteriaName, criteriaOptions } from 'common/criteria'
import { fetchRegistry, fetchUserProfile } from 'store/actions'
import InfoShort from './InfoShort'
import StyledUserProfile, { InfoDetails, MatchInfo } from './StyledUserProfile'
import CoupleTabs from '../CoupleTabs'

export const Block = ({ name, value }) => (
  <div className="row">
    <T as="div" className="category" label={name} />
    <div className="value">{value}</div>
  </div>
)

class UserProfile extends Component {
  componentDidUpdate(prevProps) {
    const nickname = this.props.match.params.nickname
    const prevNickname = prevProps.match.params.nickname

    if (nickname !== prevNickname) {
      this.fetchProfile()
    }
  }

  componentDidMount() {
    this.fetchProfile()
    this.props.fetchRegistry()
  }

  fetchProfile = () => !this.props.isMyProfile && this.props.fetchUserProfile(this.props.match.params.nickname);

  renderCriteria = (user, registry) =>
    userCriteria(user, this.props.adult)
      .map(id => {
        const selected = user.criteriaPerson1?.[id] || []
        const values = criteriaOptions(id, registry).filter(e => selected.includes(e.id))

        return (
          values.length > 0 && (
            <div className="row" key={id}>
              <span className="category">{criteriaName(id, registry)}</span>
              <span className="value">{values.map(e => e.name).join(', ')}</span>
            </div>
          )
        )
      })
      .filter(e => e);

  render() {
    const { user, registry, isMyProfile } = this.props
    const { sexes, orientations } = registry
    const match = user.matchDescriptor

    if (isMyProfile) {
      return <Redirect to="/myprofile" />
    }

    return (
      <StyledUserProfile>
        <div className="top split">
          <InfoShort className="left half split" history={this.props.history} user={user} />

          <div className="right half">
            <MatchInfo>
              <div className="group seeking-a">
                <T as="div" className="group-title" label="seeking" />
                <Block name="sex" value={match && sexes.find(s => s.id === match.lfSexIds[0])?.name} />
                <Block name="age" value={`${match?.lfAgeFrom} - ${match?.lfAgeTo}`} />
                <Block
                  name="orientation"
                  value={match && orientations.find(s => s.id === match.lfOrientationIds[0])?.name}
                />
                <Block name="country" value={user.locationInfo?.country?.name} />
              </div>
              <Block name="aboutMyMatch" value={user.aboutMyMatch} />
              <Block name="aboutMe" value={user.aboutMe} />
            </MatchInfo>

            <InfoDetails>{this.renderCriteria(user, registry)}</InfoDetails>
            {user.loaded && <CoupleTabs profile={user} notOwnProfile={true} />}
          </div>
        </div>

        <UserList limit={6} filter="matches" title="matches" />
      </StyledUserProfile>
    )
  }
}

const mapStateToProps = ({ myProfile, userProfile, registry, flags }, { match }) => ({
  user: userProfile,
  registry,
  isMyProfile: match.params.nickname == myProfile?.nickname,
  adult: flags.adult,
})

export default connect(mapStateToProps, { fetchRegistry, fetchUserProfile })(UserProfile)
